/* ===== Era definitions — single source of truth =====
   Open-ended views: only a start date, no end date, so the window keeps
   growing as days pass. Used by Analytics (built-in views, default = Era 2)
   and by the index tabs' trade-log filters (default there stays "today"). */

export const ERA_VIEWS = [
  { name: "Era 2 · New Era", from: "2026-08-14", title: "New era from 14 Aug onward (open-ended)" },
  { name: "Era 2.1 · %-Tiers", from: "2026-08-29", title: "Tier 1 = 15% of capital onward (open-ended)" },
  { name: "Era 2.2 · Prem-BE", from: "2026-09-03", title: "Premium-based breakeven onward (open-ended)" },
  { name: "Era 3 · All levels", from: "2026-10-27", title: "23.6% + 78.6% re-enabled — full fib ladder trades again (open-ended)" },
];
